import Api from "../axios";

export const addNotice = (noticeData) => {
  return Api.post("add_notice", noticeData);
};